<template>
  <div class="qr_code_installation">
    <header-component
      :is-soon="false"
      :backRoute="true"
      :progression="false"
      img-left="/trocachip/img/setinha-left-preto.svg"
      img-right="/trocachip/img/access.png"
      class="header-component"
    />
    <div class="qr_code_installation-img">
      <img src="@/assets/images/Render-icon.svg" alt="TIM eSIM" />
    </div>
    <div class="qr_code_installation_title">
      <span v-html="pageInfo.title"></span>
    </div>
    <div class="installation_instructions">
      <span class="installation_instructions_span">{{ pageInfo.sub_title }}</span>
    </div>
    <section class="instructions_list">
      <ul class="instruction_container">
        <li v-for="(step, index) in pageInfo.steps" :key="index" class="instruction_item">
          <div class="instruction_block">
            <div class="instruction_content">
              <img :src="step.image" alt="Step Icon" class="instruction_image" />
              <div class="instruction_text">
                <span class="instruction_main">{{ step.main }}</span>
                <span v-if="step.subtitle" class="instructions_subtitle">{{ step.subtitle }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </section>
    <section class="installation_tutorial_info_card">
      <div class="tutorial_content">
        <div class="text_content" :class="{ 'use-max-width': useMaxWidth }">
          <p v-html="pageInfo.footer_title" class="installation_title"></p>
          <p v-html="pageInfo.footer_subtitle" class="footer_subtitle"></p>
          <a
            href="#"
            @click.prevent="manualInstallation(pageInfo.footer_link)"
            class="QRCode_install_link">
            {{ pageInfo.footer_button }}
          </a>
        </div>        
      </div>
      <div class="footer_image">
        <div class="icon_box">
        <img :src="getImageSrc(pageInfo.footer_icon)" alt="" class="footer_icon"/>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import { mapState } from "vuex";
import HeaderComponent from "@/components/HeaderComponent.vue";
import trackEvent from "@/services/trackEvent";

export default {
  name: "QRCodeInstallation",
  components: { HeaderComponent},
  created() {
    this.sendTracker("passo_a_passo_este_aparelho", 6, 3);
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      config: (state) => state.config,
      customer: (state) => state.customer,
      pageInfo: (state) => state.config.qr_code_installation,
      useMaxWidth: (state) => state.config.qr_code_installation.useMaxWidth,
    }),
  },
  methods: {
    sendTracker(eventLabel, eventCategory = 6, eventAction = 2) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": eventCategory,
        "event-label": eventLabel,
        "event-location": "null",
        "event-value": this.customer.isExOiCustomer ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": eventAction,
      });
    },
    getImageSrc(imageName) {
      return require("@/assets/images/" + imageName);
    },
    manualInstallation(link) {
      this.sendTracker("este_aparelho_instalacao_manual");
      if (link) {
        this.$router.push({ name: link });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  .qr_code_installation {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  z-index: -1;
  > .page_content {
    margin: 25% 0%;
  }
  .qr_code_installation-img{
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 85px;
}
  .qr_code_installation_title {
    font-weight: 300;
    font-size: 27px;
    line-height: 30px;
    align-items: center;
    display: flex;
    font-family: "timsans_regular";
    width: 280px;
    text-align: center;
    flex-direction: column;
    margin: auto;
    margin-top: 1rem;
  }
  .installation_instructions {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "timsans_regular";
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    margin-top: 1rem;
    color: #696969;
    width: 325px;
    margin: auto;
  }
  .installation_instructions_span {
    margin-top: 1rem;
  }

  .instructions_list {
  padding: 0;
  margin-top: 20px;

  .instruction_container {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;  
    flex-direction: column;

    .instruction_item {
      width: 100%;
      justify-items: center;
      height: auto;
      padding: 40px 0;
      gap: 40px;
      border-bottom: 2px solid #e5e5e5;
      background: #ffffff;

      .instruction_block {
        width: 375px;
        height: auto;
        display: flex;
        align-items: center;
        gap: 24px;

        .instruction_content {
          display: flex;
          align-items: center;
          gap: 24px;
          margin: 0 15px;

          .instruction_image {
            width: 24px;
            height: 24px;
            flex-shrink: 0;
          }

          .instruction_text {
            width: 279px;
            display: flex;
            flex-direction: column;
            gap: 4px;

            .instruction_main {
              font-family: "timsans_bold";
              font-size: 14px;
              font-weight: 500;
              line-height: 21px;
              color: #000000;
            }

            .instructions_subtitle {
              font-family: "timsans_regular";
              font-size: 14px;
              line-height: 21px;
              font-weight: 400;
              color: #696969;
            }
          }
        }
      }
    }
  }
}

  .installation_tutorial_info_card {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 1.5rem;
    border-top: 2px solid #d9d9d9;    

    .tutorial_content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
    }

    .text_content {
      flex: 1;
      display: flex;
      flex-direction: column;
      width: 255px;
      &.use-max-width {
        max-width: 255px;
      }

      .installation_title {
        font-family: "timsans_regular";
        font-size: 14px;
        line-height: 21px;
        color: #000000;
        margin-bottom: 8px;
        font-weight: bold;
      }
      
      .footer_subtitle {
        font-family: "timsans_regular";
        font-size: 14px;
        color: #696969;
        line-height: 21px;
      }

      .QRCode_install_link {
        font-family: "timsans_regular";
        font-size: 16px;
        font-weight: bold;
        color: #0026D9;
        text-decoration: none;
      }
    }
    .footer_image {
      margin-top: 40px;
      margin-left: 24px
    }

    .icon_box {
      width: 48px;
      height: 48px;
      border-radius: 16px;
      border: 1px solid #e5e5e5;
      display: flex;
    }

    .footer_icon {
      margin: auto;
    }
  }
}

</style>